import React from "react";
import dynamic from "next/dynamic";
import styles from "../../styles/pages/emptwin.module.scss";
const Icons = dynamic(() => import("../../public/assets/svg/index"));
const Card = dynamic(() => import("../dynamicBotCard"));
import Carousels from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import endpoints from "../../utility/endpoints";
const BasicForm = dynamic(() => import("../basicForm"));
const Video = dynamic(() => import("../../pages/videoModal"));
const Empbanner = dynamic(() => import("../emptwinskillBanner"));
const Emptwinskills = dynamic(() => import("../emptwinskillscart/"));
const Filters = dynamic(() => import("../Filtersemptwin"));
import _get from "lodash/get";
import { useRouter } from "next/router";
import ReactPlayer from "react-player";
import axios from "axios";
import { useState, useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
const SuccessModal = dynamic(() => import("../../pages/successModal"));
import { useMediaQuery } from "react-responsive";
const Loader = dynamic(() => import("../Loader"));
import { sessionTimeOutCheck, checkExpiry } from "../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CartModal from "../Pages/Cartmodal";

function index(props) {
  const router = useRouter();
  console.log("props  ------ Employeetwin page  -----", props);

  let initialStates = {};
  let [state, setState] = React.useState(initialStates);
  const [submitForm, setSubmitForm] = React.useState(false);
  const [invalidFlag, setInvalidFlag] = React.useState(false);
  const [getFormValues, setGetFormValues] = React.useState(false);
  const [emptyFormValues, setEmptyFormValues] = React.useState(false);
  const [bots, setBots] = React.useState([]);
  const [successModal, setSuccessModal] = React.useState(false);
  const [cartModal, setCartModal] = React.useState(false);
  const [empdata, setEmpdata] = useState([]);
  const backgroundUrlMobile = _get(
    props.data[0],
    "component.content.field_background_image_mobile[0]",
    ""
  );
  const backgroundUrl = _get(
    props,
    "data[0]component.content.field_background_image[0].file_url",
    ""
  );

  const emptwinDetails = _get(
    props,
    "data[0].component.content.field_details",
    ""
  );
  const emptwinHeading = _get(
    props,
    "data[0]component.content.field_hedaing",
    ""
  );
  const backgroundUrlMobile1 = _get(
    props.data[10],
    "component.content.field_background_image_mobile[0]",
    ""
  );
  const backgroundUrl1 = _get(
    props,
    "data[10]component.content.field_background_image[0].file_url",
    ""
  );
  const backgroundUrl11 = _get(
    props,
    "data[0].component.content.field_background_image[1].file_url",
    ""
  );
 console.log('backgroundUrl11',backgroundUrl11);
// console.log('getting all images',props.data[0].component.content.field_background_image[1].file_url);
  const emptwinDetails1 = _get(
    props,
    "data[10].component.content.field_details",
    ""
  );
  const emptwinHeading1 = _get(
    props,
    "data[10]component.content.field_hedaing",
    ""
  );
  const backgroundUrlMobileemptwin = _get(
    props.data[11],
    "component.content.field_background_image_mobile[0]",
    ""
  );
  const backgroundUrlemptwin = _get(
    props,
    "data[11]component.content.field_background_image[0].file_url",
    ""
  );



  const goTo = (link) => {
    // console.log(link);
    router.push(link);
  };
  function openpopup()
  {
    let modal = !cartModal;
    setCartModal(true);
    if (modal === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }


  const moveToCez = (sectionName) => {
    router.push({
      pathname: props.pageRoutes.CognitiveExperienceZone,
      query: { cezSection: sectionName },
    });
  };
  const empid = JSON.parse(localStorage.getItem('empid'))
  
 console.log(empid)
  const localHandler = async (e) => {
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    const { data } = await axios({
      url: `${endpoints.baseUrl}/twin/search?empTwinId=${empid}`,
      method: "GET",
      headers: {
        Authorization: `${auth.accessToken}|${auth.email}`,
      },

    });
    console.log(data);
    if (data.code === 200) {
      setEmpdata(data.allSkill[0]);

    }
    else
    {
      console.log("No data found")
    }
  
}

  const reactRef = React.useRef(null);

React.useEffect(() => {
  localHandler();
},[])

console.log(empdata)
  return (
    <div className={`${styles.landingContainer}`}>
      {successModal ? (
        <SuccessModal
          setSuccessModal={setSuccessModal}
          title={"Request a demo"}
          message={message}
        />
      ) : null}
      <div id="headTop"></div>
      <Empbanner
        data={{
          emptwinDetails,
          emptwinHeading,
          backgroundUrl,
          backgroundUrl11,
          backgroundUrlMobile,
        }}
        name = "employeetwinskills"
        empid={empid}
        empdata={empdata}
      />
      <Emptwinskills
        data={{
          emptwinDetails1,
          emptwinHeading1,
          backgroundUrl1,
          backgroundUrlMobile1,
        }}
        name = "employeetwinskills"
        allskillsData={props.data}
        data1={props.softskill1}
        empid={empid}
      />
      {/* <div className={`${styles.btndiv} col-md-12 `}>
      
        <button  onClick={() => {openpopup()}} className={styles.addtocartbtn}>Add To Cart</button>
        </div> */}
        {
        cartModal ? (
          <CartModal
            data={props.softskill.data.field_component}
            closeModal={() => {
              setCartModal(false);
            }}
            pageRoutes={props.pageRoutes}
           
            empid={empid}
          />
        ) : null
      }
    </div>
  );
}

const mapStateToProps = (state) => {
  console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);

